<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      {{ modalContent.title }}
    </Teleport>

    <cf-validated-form
      v-if="showCheckBalanceform"
      :disabled="isCheckingBalance"
      name="addGiftCard"
      @valid-submit="checkGiftCardBalanceSubmitFormHandler"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <p class="cf-subtitle cf-subtitle--2">
          {{ modalContent.description }}
        </p>

        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16">
          <div class="cf-flex cf-flex--grow-1">
            <cf-text-input
              v-model="giftCardNumber"
              type="text"
              :label="modalContent.giftCardInputLabel"
              name="giftCardNumber"
              inputmode="numeric"
              mask="giftCard"
              :validations="{
                required: true
              }"
            />
          </div>

          <div
            v-if="isGiftCardPinRequired"
            class="cf-flex cf-flex--no-shrink cf-flex--flex-basis-md"
          >
            <cf-text-input
              v-model="giftCardPin"
              type="text"
              :label="modalContent.pinInputLabel"
              name="giftCardPin"
              allowed-characters="0-9a-zA-Z"
              inputmode="numeric"
              :validations="{
                required: true
              }"
            />
          </div>
        </div>

        <button
          class="cf-button cf-button--primary cf-button--lg cf-button--fill"
          :class="{ 'cf-button--loading': isCheckingBalance }"
          type="submit"
        >
          {{ modalContent.checkBalanceCta }}
        </button>
      </div>
    </cf-validated-form>

    <div
      v-else
      class="cf-flex cf-flex--column cf-flex--gap-12"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-10">
        <h1 class="cf-title cf-title--1">
          {{ remainingBalance }}
        </h1>

        <p class="cf-subtitle cf-subtitle--2">
          {{ modalContent.balanceRemainingTitle }}
        </p>
      </div>

      <button
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        type="submit"
        @click="confirmRemainingBalanceClickHandler"
      >
        {{ modalContent.balanceRemainingCta }}
      </button>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import dollars from '@/filters/dollars';

  import errorHandlers from '@/services/error-handlers';


  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';
  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';


  export default {
    name: 'CheckGiftCardBalance',

    components: {
      CfTextInput,
      CfValidatedForm
    },

    data() {
      return {
        giftCardNumber: null,
        giftCardPin: null,
        isCheckingBalance: false,
        showCheckBalanceform: true,
        remainingBalance: null
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('locations', ['selectedLocation']),

      isGiftCardPinRequired() {
        return this.merchant.defaultPaymentGateway?.methods?.giftCard.giftCardPinRequired || this.selectedLocation?.paymentGateway?.methods?.giftCard?.giftCardPinRequired;
      },

      modalContent() {
        const {
          metadata,
          title,
          description
        } = this.content.CheckGiftCardBalance;

        const {
          balanceRemainingCta,
          balanceRemainingTitle,
          checkBalanceCta,
          inputGiftCardNumber: giftCardInputLabel,
          inputPin: pinInputLabel
        } = metadata;

        return {
          title,
          description,
          balanceRemainingCta,
          balanceRemainingTitle,
          checkBalanceCta,
          giftCardInputLabel,
          pinInputLabel
        };
      }
    },

    methods: {
      async checkGiftCardBalanceSubmitFormHandler() {
        try {
          this.isCheckingBalance = true;

          const dispatchPayload = {
            cardNumber: this.giftCardNumber,
            pin: this.giftCardPin
          };

          const response = await this.$store.dispatch('giftCards/checkCardBalance', dispatchPayload);

          this.showCheckBalanceform = false;

          this.remainingBalance = dollars(response.amount);
        }
        catch (error) {
          errorHandlers.generic(error);
        }
        finally {
          this.isCheckingBalance = false;
        }
      },

      confirmRemainingBalanceClickHandler() {
        this.$closeModal('checkGiftCardBalanceModal');
      }
    }
  };
</script>
